import { BaaForm } from './hipaa-types';

export function validateBaaForm(baa: BaaForm): boolean {
  // every field except `valid` is required
  const isValid = validateEveryProperty(baa);

  return isValid;
}

function validateEveryProperty(obj: { [name: string]: ExplicitAny }): boolean {
  if (!obj) {
    return false;
  }

  // consider inverting the checks and looking for the first invalid
  // field and returning early if performance becomes an issue
  const isValid = Object.entries(obj).every(([_, value]) => {
    if (typeof value === 'object') {
      return validateEveryProperty(value);
    }

    // valid values are that are not null, undefined, or empty strings
    if (typeof value === 'undefined' || value === null) {
      return false;
    }

    if (value === '') {
      return false;
    }

    return true;
  });

  return isValid;
}
